import { formatDateAndMonthToLiteral } from "../MyTrips/MyTrips.util";
import { addAproxText } from "../ResumeRoute/ResumeRoute.util";
import { convertLegIdsToNumbers } from "../TripSelector/TripSelector.util";

export function multimodalCardMapping(data: any,t:any,type:any,discountToApply=0,typePst?:any) {


  let resultDeparture=[] as any
  let resultTrainDeparture=[] as any
    data?.map((item: any) => {
    if(item.informative===false && (item.icon!=="ave" && item.icon!=="cercanias")){
    const date = new Date(item.departureDate)
    let dateAux= date.toLocaleDateString("es-ES", {
      month: "short",
      day: "2-digit",
    });
    const aux={
    text: item.transport,
    price: item.price,
    priceNumber: item.priceNumber,
    departure: item.route,
    arrival:item.destiny ,
    date:dateAux ,
    rangetime:item.departureTime+ " - "+item.arrivalTime ,
    num: item.passager,
    totalPriceWithoutExtras: item.totalPriceWithoutExtras,
    icon:item.icon,
    line:item.line,
    transport:item.transport,
    priceFinal:item.priceNumber,
    idTariff:item.idTariff,
    type:type,
    //isPaidTrip:item.isPaidTrip ? item.isPaidTrip: false,
    status:item.status ? item.status:'PAID',
    ...item
    }
    resultDeparture.push(aux)
  }else if(item.informative===false && (item.icon==="ave" || item.icon==="cercanias")){
    const date = new Date(item.departureDate)
    let dateAux= date.toLocaleDateString("es-ES", {
      month: "short",
      day: "2-digit",
    });
    const aux={
    text: item.icon==="ave" ? t('ave'):t('cercanias'),
    price: item.price,
    priceNumber: item.priceNumber,
    departure: item.route,
    arrival:item.destiny ,
    date:dateAux ,
    rangetime:item.departureTime+ " - "+item.arrivalTime ,
    num: item.passager,
    totalPriceWithoutExtras: item.totalPriceWithoutExtras,
    transport:item.transport,
    line:item.line,
    icon:item.icon,
    priceFinal:item.price,
    idTariff:item.idTariff,
    type:type,
    //isPaidTrip:item.isPaidTrip ? item.isPaidTrip: false,
    status:item.status ? item.status:'PAID',
    ...item
    }
    resultTrainDeparture.push(aux)

  }
  });
  let sumPreci=resultTrainDeparture?.reduce((prev: any, current: any) => prev + current?.priceNumber, 0)

  if(typePst==="ave" ||typePst==="cercanias"  ){
    resultTrainDeparture=resultTrainDeparture.map((ex: any) => {
      return{
        ...ex,
      sumTotal:discountToApply,
  
  }})
  }else{
    resultTrainDeparture=resultTrainDeparture.map((ex: any) => {
      return{
        ...ex,
      sumTotal:sumPreci
  
  }})
  }
  
  if(type==="departure"){
    return {resultDeparture,resultTrainDeparture} ;
  }else{
    let resultArrival=resultDeparture
    let resultTrainArrival=resultTrainDeparture
    return {resultArrival,resultTrainArrival} ;
  }

}


export function multimodalCardMappingApplyDiscount(data: any,t:any,type:any,discountToApply=0,typePst:any,idTariff:any) {

  let resultDeparture=[] as any
  let resultTrainDeparture=[] as any
    data?.map((item: any) => {
    if(item.informative===false && (item.icon!=="ave"&& item.icon!=="cercanias")){
    const date = new Date(item.departureDate)
    let dateAux= date.toLocaleDateString("es-ES", {
      month: "short",
      day: "2-digit",
    });
    const aux={
    text: item.transport,
    price: item.price,
    priceNumber: item.priceNumber,
    departure: item.route,
    arrival:item.destiny ,
    date:dateAux ,
    rangetime:item.departureTime+ " - "+item.arrivalTime ,
    num: item.passager,
    totalPriceWithoutExtras: item.totalPriceWithoutExtras,
    icon:item.icon,
    line:item.line,
    transport:item.transport,
    //priceFinal:item.idTariff ===idTariff ?  discountToApply :item.priceNumber,
    priceFinal:item.priceNumber,
    idTariff:item.idTariff,
    type:type,
   // isPaidTrip:item.isPaidTrip ? item.isPaidTrip: false,
       status:item.status ? item.status:'PAID'

    }
    resultDeparture.push(aux)
  }else if(item.informative===false && (item.icon==="ave"||item.icon==="cercanias" )){
    const date = new Date(item.departureDate)
    let dateAux= date.toLocaleDateString("es-ES", {
      month: "short",
      day: "2-digit",
    });
    const aux={
    text: item.icon==="ave" ? t('ave'):t('cercanias'),
    price: item.price,
    priceNumber: item.priceNumber,
    departure: item.route,
    arrival:item.destiny ,
    date:dateAux ,
    rangetime:item.departureTime+ " - "+item.arrivalTime ,
    num: item.passager,
    totalPriceWithoutExtras: item.totalPriceWithoutExtras,
    transport:item.transport,
    line:item.line,
    icon:item.icon,
    idTariff:item.idTariff,
    type:type,
    //isPaidTrip:item.isPaidTrip ? item.isPaidTrip: false,
    status:item.status ? item.status:'PAID'
    }
    resultTrainDeparture.push(aux)

  }
  });
  let sumPreci=resultTrainDeparture?.reduce((prev: any, current: any) => prev + current?.priceNumber, 0)

  if(typePst==="ave" || typePst==="cercanias"){
    resultTrainDeparture=resultTrainDeparture.map((ex: any) => {
      return{
        ...ex,
      sumTotal:sumPreci,
      priceFinal:sumPreci

  
  }})
  }else{
    resultTrainDeparture=resultTrainDeparture.map((ex: any) => {
      return{
        ...ex,
      sumTotal:sumPreci
  
  }})
  }
  

  if(type==="departure"){
    return {resultDeparture,resultTrainDeparture} ;
  }else{
    let resultArrival=resultDeparture
    let resultTrainArrival=resultTrainDeparture
    return {resultArrival,resultTrainArrival} ;
  }

}




export function multimodalCardMappingDelete(data: any,t:any,type:any,discountToApply=0,typePst?:any) {


  let result=[] as any
  let resultTrain=[] as any

    data?.map((item: any) => {
    if(item.informative===false && item.icon!=="ave" && item.icon!=="cercanias"){
    const date = new Date(item.departureDate)
    let dateAux= date.toLocaleDateString("es-ES", {
      month: "short",
      day: "2-digit",
    });
    const aux={
    text: item.transport,
    price: item.price,
    priceNumber: item.priceNumber,
    departure: item.route,
    arrival:item.destiny ,
    date:dateAux ,
    rangetime:item.departureTime+ " - "+item.arrivalTime ,
    num: item.passager,
    totalPriceWithoutExtras: item.totalPriceWithoutExtras,
    icon:item.icon,
    line:item.line,
    transport:item.transport,
    priceFinal:item.priceNumber,
    idTariff:item.idTariff,
    type:item.type,
    //isPaidTrip:item.isPaidTrip
    status:item.status
    }
    result.push(aux)
  }else if(item.informative===false && (item.icon==="ave"||item.icon==="cercanias" )){
    const date = new Date(item.departureDate)
    let dateAux= date.toLocaleDateString("es-ES", {
      month: "short",
      day: "2-digit",
    });
    const aux={
    text: item.icon==="ave" ? t('ave'):t('cercanias'),
    price: item.price,
    priceNumber: item.priceNumber,
    departure: item.route,
    arrival:item.destiny ,
    date:dateAux ,
    rangetime:item.departureTime+ " - "+item.arrivalTime ,
    num: item.passager,
    totalPriceWithoutExtras: item.totalPriceWithoutExtras,
    transport:item.transport,
    line:item.line,
    icon:item.icon,
    idTariff:item.idTariff,
    type:item.type,
    //isPaidTrip:item.isPaidTrip 
    status:item.status
    
    }
    resultTrain.push(aux)

  }
  });
  let sumPreci=resultTrain?.reduce((prev: any, current: any) => prev + current?.priceNumber, 0)

  if(typePst==="ave" || typePst==="cercanias"){
    resultTrain=resultTrain.map((ex: any) => {
      return{
        ...ex,
      sumTotal:discountToApply,
      priceFinal:discountToApply
  
  }})
  }else{
    resultTrain=resultTrain.map((ex: any) => {
      return{
        ...ex,
      sumTotal:sumPreci
  
  }})
  }
  

  return {result,resultTrain} ;
  /*if(type==="departure"){
    return {result,resultTrain} ;
  }else{
    let resultArrival=resultDeparture
    let resultTrainArrival=resultTrainDeparture
    return {resultArrival,resultTrainArrival} ;
  }*/

}

export function sumTotalTrain(data: any) {
  let total=data?.reduce((prev: any, current: any) => prev + current?.priceNumber, 0)

  data=data.map((ex: any) => {
    return{
      ...ex,
    sumTotal:total,


}})

return data
}

/**
 * Mapea el PST que esta pagado o no
 */
export function mappedIsPaidTrip(data: any,dataConfirm:any, typeTrip: any) {
  let result={
    ...data,
    summaryAmount: {
      [typeTrip]: {
        ...data.summaryAmount[typeTrip],
        transports: data.summaryAmount[typeTrip].transports.map((ex: any,) => {
         // Buscar coincidencia de idLeg en dataConfirm
         
         const matchingConfirm = dataConfirm?.find((confirm:any) => confirm.idLeg === convertLegIdsToNumbers(ex.idTariff) ||confirm.idLeg.toString() === ex.idTariff );

         // Si hay coincidencia, devuelve todos los datos más el status
         if (matchingConfirm) {
           return {
             ...ex,
             status: matchingConfirm.status, // Añadir el status del dataConfirm
             paymentStatus:matchingConfirm?.paymentInfo?.paymentStatus ? matchingConfirm?.paymentInfo?.paymentStatus : "ERROR",
             isDiscountApplied:matchingConfirm?.price?.concepts?.some((item:any) => item.name==="DOCO_DISCOUNT"),
             activePstDiscount:getActivePstDiscount(matchingConfirm.status,matchingConfirm?.paymentInfo?.paymentStatus ),
             paymentInfo:matchingConfirm?.paymentInfo?.paymentMethod ? matchingConfirm?.paymentInfo?.paymentMethod :"CREDIT_CARD"//Revisar esto

           };
         }
         
         // Si no hay coincidencia, devuelve el objeto original sin modificaciones
         return ex;
      }),
      },
    },
  }


  return result;
}



/**
 * Mapea el PST que esta pagado o no
 */
export function getStatusTrip(typeTrip: any,data:any) {
  let type=typeTrip.payReturn===false ?"outwardJourney":"returnJourney", index=typeTrip.indexToPay;
  let idLeg=typeTrip[type].selectedTariff[index].idLeg

  let result=data[type].selectedTariff.find((item:any) => item.idLeg === idLeg).status;
  if(result==="BOOKED"){

  }
  return result;
}


/**
 * Mapea el PST que esta pagado o no
 */
export function getActivePstDiscount(orderStatus: any,paymentStatus:any) {

  let result=true
    switch (orderStatus) {
      case 'BOOKED':
        result=true;
        break;
    
      case 'FAILED':
        if(paymentStatus==="SUCCESS"  ){
          result=false;
        }else{
          result=true;
        }
        break;
      case 'VALID':
          if(paymentStatus==="SUCCESS"){
            result=true;
        }else{
            result=false;
      }
          break;
       case 'PENDING_PAYMENT':
          if(paymentStatus===undefined){
            result=false;
        }else{
            result=true;
        }
        break;
        case 'PAID':
          result=false;
          break;
      default:
        break;
    }
    return result;
  }
  
  





export interface IMultiModalCard {
  text:                    string;
  price:                   string;
  priceNumber:             number;
  departure:               string;
  arrival:                 string;
  date:                    string;
  rangetime:               string;
  num:                     string;
  totalPriceWithoutExtras: number;
}
